import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import { Paper, Typography, FormControl, InputLabel, MenuItem, Select, DialogContentText } from '@material-ui/core';
import MUIDataTable from 'mui-datatables';
import { parse, format, subMonths } from 'date-fns';
import classnames from 'classnames';

const styles = theme => ({
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  body: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  selectTipo: {
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 5,
    width: 830,
  },
  fontTable: {
    fontSize: 12
  },
  total: {
    fontSize: 12,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 4,
    marginLeft: theme.spacing.unit * 2,
    color: theme.palette.text.secondary,
  },
  tableRowCancelado: {
    backgroundColor: '#f2dede',
  },
});

class FormDialogBaixasPagto extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      baixas: [],
      valTotalBaixado: 0,
    };
  }
  componentDidMount = async () => {
      let baixasAux = this.props.baixas;
      let baixas = [];
      let valTotalBaixado = 0;
      baixasAux.map(res => {
        const { seqPagto, numDivida, valDivida, valBaixado, dtaPagto, txtObservacao, dtaCancelamento, txtMotivoCancelamento, codUsuarioCancelamento } = res;
        let brancoAcoes = '';
        if (codUsuarioCancelamento.trim() === ''){
          valTotalBaixado = valTotalBaixado + valBaixado;
        }
        baixas.push(Object.values({ seqPagto, numDivida, valDivida, valBaixado, dtaPagto, txtObservacao, dtaCancelamento, txtMotivoCancelamento, codUsuarioCancelamento, brancoAcoes }));
      });      
      this.setState({baixas: baixas, valTotalBaixado: valTotalBaixado});
    }

  render () {
    const options = {
      setRowProps: (row) => {
        return {
          title: row[8].trim() !== '' ? 'Registro Cancelado por ' + row[8].trim() + ' em ' + row[6].props.children + ' MOTIVO: ' + row[7] : '',
          className: classnames(
            {
              [this.props.classes.tableRowCancelado]: row[8].trim() !== '',
            }, this.props.classes.tableRow),
        };
      },
      print: false,
      download: false,
      filterType: 'dropdown',
      selectableRows: false,
      rowsPerPageOptions: [5, 10, 15],
      rowsPerPage: 10,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        toolbar: {
          search: 'Procurar',
          viewColumns: 'Ver Colunas',
          filterTable: 'Filtrar',
        },
        filter: {
          all: 'Todos',
          title: 'FILTROS',
          reset: 'RESET',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
        selectedRows: {
          text: <Typography style={{display: 'inline'}}>registro(s) selecionado(s)</Typography>,
        },
      }
    };
    const columns = [
      {
        name: 'Seq. Pagto.',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Num. Dívida',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Valor Dívida',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        }
      },
      {
        name: 'Valor Baixado',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
          setCellProps: () => {
            return {
              className: classes.fontTable
            };
          },
        }
      },
      {
        name: 'Data Reg. Dívida',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value !== null ? <Typography style={{fontSize: 12}}>{format(new Date(value), 'DD/MM/YYYY')}</Typography> : '-';
          },
        }
      },
      {
        name: 'txtObservacao',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value) => {
            return value.trim() === '' ? '-' : value;
          },
        }
      },
      {
        name: 'dtaCancelamento',
        options: {
          display: 'excluded',
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value !== null ? <Typography style={{fontSize: 12}}>{format(new Date(value), 'DD/MM/YYYY')}</Typography> : '-';
          },
        }
      },
      {
        name: 'txtMotivoCancelamento',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'codUsuarioCancelamento',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
      {
        name: 'Ações',
        options: {
          display: 'excluded',
          filter: false,
          sort: false,
        }
      },
    ];
    const { classes, open, handleClose, titulo } = this.props;
    const { baixas } = this.state;
    const nf = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='md'
          fullWidth
          open={open}
          onClose={handleClose}
        >
          <DialogTitle>
            {titulo}
          </DialogTitle>
          <DialogContent>
          <Paper className={classes.body} elevation={1}>
              <MUIDataTable
                data={baixas}
                columns={columns}
                options={options}
              />
              <Typography className={classes.total}>TOTAL BAIXADO: {nf.format(this.state.valTotalBaixado)}</Typography>
            </Paper>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogBaixasPagto);
